import React from 'react';
import { STEPS } from '../mvData';

export default function ProgressStepper({ vm, t, onSelect }) {
  return (
    <div className="mv-progress">
      {STEPS.map((item, index) => {
        const unlocked = isUnlocked(item, vm);
        const done = isDone(item, vm);
        const active = vm.step === item;
        return (
          <button
            key={item}
            className={`${active ? 'active' : ''} ${done ? 'done' : ''} ${unlocked ? '' : 'locked'}`}
            disabled={!unlocked}
            onClick={() => onSelect(item)}
          >
            <span>{done ? '✓' : index + 1}</span>
            <strong>{t(`videoGeneration.mv.steps.${item}`)}</strong>
            <small>{t(`videoGeneration.mv.flow.${statusKey(active, done, unlocked)}`)}</small>
          </button>
        );
      })}
    </div>
  );
}

function isUnlocked(step, vm) {
  if (step === 'lyrics') return true;
  if (step === 'music') return vm.lyrics.length > 0;
  return !!vm.music;
}

function isDone(step, vm) {
  if (step === 'lyrics') return vm.lyrics.length > 0;
  if (step === 'music') return !!vm.music;
  return !!vm.mv;
}

function statusKey(active, done, unlocked) {
  if (active) return 'current';
  if (done) return 'done';
  return unlocked ? 'available' : 'locked';
}
